export type OnboardingStep = 'locations' | 'leaveTypes' | 'departments' | 'import'

export interface IOnboardingLocation {
  id: string
  name: string
  countryCode: string
  subdivisionCode: string | null
  isFromSignup?: boolean
}

export interface ILeaveTypeOverride {
  locationId: string
  locationName: string
  daysPerYear: number
  hasUnlimitedDays: boolean
  isApprovalRequired: boolean
  allowHalfDays: boolean
  shortestLeaveIntervalEnum: string
}

export interface IOnboardingLeaveType {
  id: string
  name: string
  color: string
  isActive: boolean
  isFromDefault: boolean
  hasUnlimitedDays: boolean
  daysPerYear: number
  isApprovalRequired: boolean
  allowHalfDays: boolean
  shortestLeaveIntervalEnum: string
  appliesToAll: boolean
  appliesTo: string[]
  overrides: ILeaveTypeOverride[]
}

// The feed's shape lives in shared/types/leave-law.ts - the backend derives policies from the
// same data. Re-exported under the old names so existing imports keep working.
export type {
  ILeaveLawSuggestion as ILeaveTypeSuggestion,
  ILeaveLawEntry as ILeaveTypeLocationData,
  LeaveLawsResponse as LeaveTypesApiResponse,
} from '@vacationtracker/shared/types/leave-law'

export interface IOnboardingDepartment {
  id: string
  name: string
  isDefault?: boolean
  initialName?: string
}

export interface IImportMember {
  id: string
  name: string
  email: string
  initials: string
  locationId?: string
  departmentId?: string
  originalLocationName?: string
  originalDepartmentName?: string
}

export const LEAVE_TYPE_COLORS = ['#7c3aed', '#0d9488', '#dc2626', '#d97706', '#2563eb', '#ea580c', '#16a34a']

export const QUICK_ADD_DEPARTMENTS = ['Engineering', 'Marketing', 'Operations', 'HR', 'Finance', 'Product', 'Support']

export const INTERVAL_TO_I18N_KEY: Record<string, string> = {
  'FULL-DAY': 'onboarding.setup.minDuration.fullDay',
  'HALF-DAY': 'onboarding.setup.minDuration.halfDay',
  'ONE-HOUR': 'onboarding.setup.minDuration.oneHour',
  'HALF-HOUR': 'onboarding.setup.minDuration.halfHour',
  'FIFTEEN-MINUTES': 'onboarding.setup.minDuration.15min',
}

export const INTERVAL_ENUM_VALUES = ['FULL-DAY', 'HALF-DAY', 'ONE-HOUR', 'HALF-HOUR', 'FIFTEEN-MINUTES'] as const

// Normalize API / legacy values to the backend enum format
export const normalizeIntervalEnum = (value: string | null | undefined): string => {
  if (!value) return 'FULL-DAY'
  if (value === '15MIN') return 'FIFTEEN-MINUTES'
  return value
}
